package com.artvending.warden

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.alignSelf
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.bottom
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.left
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.minWidth
import org.jetbrains.compose.web.css.opacity
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.right
import org.jetbrains.compose.web.css.top
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

class JsDialog : Dialog {
	var messageDialogTitle by mutableStateOf("")
	var messageDialogContent by mutableStateOf<@Composable () -> Unit>({})
	var isDialogOpen by mutableStateOf(false)
	var closedHandler: () -> Unit = {}
	
	override fun show(title: String, text: String, closeHandler: (() -> Unit)?) {
		messageDialogTitle = title
		
		messageDialogContent = @Composable {
			Div({ style { alignSelf(AlignSelf.Center) } }) {
				Text(text)
			}
			
			LaunchedEffect(Unit) {
				isDialogOpen = true
			}
		}
		
		closedHandler = {
			messageDialogContent = {}
			closeHandler?.invoke()
		}
	}
	
	override suspend fun showAndWaitNotImplemented(title: String, text: String) {
		action<Unit> { release ->
			show(title, text){
				release()
			}
		}
	}
	
	
	@Composable
	override fun Display() {
		Div({
			style {
				top(0.px); left(0.px); bottom(0.px); right(0.px);
				position(Position.Absolute);
				property("z-index", "998")
				if (!isDialogOpen) property("visibility", "collapse")
			}
		}) {
			Div({ style { top(0.px); left(0.px); bottom(0.px); right(0.px);backgroundColor(Color.black); opacity(0.33); position(Position.Absolute) }; })
			Column_({ style { top(0.px); left(0.px); bottom(0.px); right(0.px); position(Position.Absolute); justifyContent(JustifyContent.Center) } }) {
				Card({
					style {
						alignSelf(AlignSelf.Center);
						gap(settings.space);
						padding(settings.space)
						margin(settings.space)
						minWidth(240.px);
						borderRadius(18.px);
						backgroundColor(Color.white)
					}
				}) {
					Div({ classes(settings.titleFontClass) }) {
						Text(messageDialogTitle)
					}
					Div {
						messageDialogContent.invoke()
					}
					Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.FlexEnd); gap(settings.space) } }) {
						TextButton({ isDialogOpen = false; closedHandler() }) {
							Text("Ок")
						}
					}
				}
			}
		}
	}
}